import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AppBar, Avatar, Toolbar, IconButton, Tooltip } from '@mui/material';
import navbarLogo from '../../../images/logo_loginscreen.png';
import styles from './Navbar.module.css';
import Sidebar from '../Sidebar/Sidebar';
import Logout from './../../../images/logout.png';
import { useUserContext } from '../../../Context/UserContext';
import defaultUserImage from "../../../images/user.png";
import { apiPost } from '../../../utils/ApiManager';
import { useToastContext } from '../../../Context/ToastContext';

const adminLogout = process.env.REACT_APP_ADMIN_LOGOUT


const Navbar = () => {
  const { userRole, logout, requestConfirmation } = useUserContext();
  const { showToast } = useToastContext();
  const navigate = useNavigate();

  const [storedImg, setStoredImg] = useState(
    localStorage.getItem("profileImage") || null
  );

  const handleLogoutConfirm = async () => {
    const result = await requestConfirmation("Want to log out?");
    if (!result) return;
    try {
      const response = await apiPost(adminLogout);
      if (response?.success) {
        localStorage.clear();
        logout();
        window.location.href = '/login';
      } else {
        showToast(response?.message || "Something went wrong", "error");
      }
    } catch (error) {
      showToast(error?.response?.message || error?.message || "Failed to logout !", 'error')
    }
  };

  const handleAvatarClick = () => {
    navigate('/profile');
  };

  const handleStorageChange = () => {
    const updatedImage = localStorage.getItem("profileImage");
    setStoredImg(updatedImage);
  };

  useEffect(() => {
    const storedImageData = localStorage.getItem("profileImage");
    setStoredImg(storedImageData);
  }, []);

  useEffect(() => {
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return (
    <AppBar position="sticky" className={styles.theNavbar}>
      <Toolbar className={styles.navbarflex}>
        <div className={styles.navbarContainer}>
          {userRole() && <Sidebar />}
          <Link to="/">
            <img src={navbarLogo} className={styles.navbarLogo} alt="logo" />
          </Link>
        </div>

        {userRole() && (
          <div className={styles.navbarProfileContainer}>
            <Tooltip title="My Profile" arrow>
              <Avatar
                src={
                  storedImg && storedImg !== "null"
                    ? `data:image/png;base64,${storedImg}`
                    : defaultUserImage
                }
                alt="User Profile"
                onClick={handleAvatarClick}
                style={{ width: 25, height: 25, cursor: "pointer", }}
              />

            </Tooltip>

            <Tooltip title="Logout" arrow>
              <IconButton onClick={handleLogoutConfirm} style={{ marginLeft: "10px" }}>
                <img src={Logout} alt="Logout" style={{ width: 23, height: 23 }} />
              </IconButton>
            </Tooltip>
          </div>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
